import axios from "./axios"

class Get {
  async device(mac) {
    return axios()
      .get("/api/get/device/" + mac)
      .catch(err => _$.error(err))
  }
  async config() {
    return axios()
      .get("/api/get/config")
      .then(data => {
        if (typeof data !== "object") return data

        Object.keys(data).forEach(key => {
          let value = "" + data[key],
            checker = value.split(".").pop()
          if (["jpg", "jpeg", "png", "gif"].indexOf(checker.toLowerCase()) !== -1) value = value.host()
          else if (["mp4", "avi", "ts", "mkv"].indexOf(checker.toLowerCase()) !== -1) value = value.host()

          data[key] = value

          if (value === "" || value === "null") data[key] = null
        })

        return data
      })
      .catch(err => _$.error(err))
  }
  async menus() {
    return axios()
      .get("/api/get/navigation")
      .then(data => {
        if (!Array.isArray(data)) return data

        const convert = menu => {
          const hasicon = _$.true(["flaticon", "fa"].find(item => menu.image?.startsWith(item)))

          if (!hasicon && menu.image_type.includes("icon")) menu.image_type = "iconi"
          if (["iconi", "image"].includes(menu.image_type)) menu.image = ("" + menu.image).host("/uploads/")

          menu.isShow = menu.isShow === "1" ? true : false

          if (menu.subs) menu.subs.forEach(item => (item = convert(item)))
          return menu
        }

        return data.map(menu => {
          return convert(menu)
        })
      })
      .catch(err => _$.error(err))
  }
  async cms(target) {
    return axios()
      .get(`/api/get/cms/${target}`)
      .then(data => {
        if (!Array.isArray(data)) return data

        for (const category of data) {
          category.active = 0
          for (const page of category.items) {
            page.video = page.video ? page.video.host() : null
            page.cover = page.cover ? JSON.parse(page.cover) : {}

            page.gallery = !page.gallery ? [] : page.gallery.map(image => JSON.parse(image))
            if (page.show_in_detail == 1) page.gallery.unshift(page.cover)
          }
        }
        return data
      })
      .catch(err => _$.error(err))
  }
  async vods() {
    return axios()
      .get("/api/get/vods")
      .then(data => {
        if (!Array.isArray(data)) return data

        return data.map(vod => {
          vod.cover = ("" + vod.cover).host("/media/vod/banners/")
          vod.poster = ("" + vod.poster).host("/media/vod/banners/")
          vod.trailer = ("" + vod.trailer).host("/media/vod/trailers/")
          vod.url = ("" + vod.url).host("/media/vod/movies/")

          return vod
        })
      })
      .catch(err => _$.error(err))
  }
  async channels() {
    return axios()
      .get("/api/get/channels")
      .then(data => {
        if (!Array.isArray(data)) return data

        return data.map(channel => {
          channel.hasDvr = _$.true(channel.hasDvr)
          channel.logo = ("" + channel.logo).host("/media/iptv/channelicons/")
          if (!channel.type.startsWith("RF") && !channel.type.startsWith("ANALOG")) channel.channel_uri = ("" + channel.channel_uri).host()

          return channel
        })
      })
      .catch(err => _$.error(err))
  }
  async epgs(target, date = null) {
    return axios()
      .get(`/api/get/epgs/${target}/${date || new Date().getTime()}`)
      .catch(err => _$.error(err))
  }
  async languages() {
    return axios()
      .get("/api/get/languages")
      .catch(err => _$.error(err))
  }
  async actions(payload) {
    return axios()
      .post("/api/get/actions", payload)
      .catch(err => _$.error(err))
  }
  async cdn(payload) {
    return axios()
      .post("/api/get/cdn", payload)
      .catch(err => _$.error(err))
  }
  async billview(payload) {
    return axios()
      .post("/Api/billview.php", payload)
      .catch(err => _$.error(err))
  }
  async records() {
    return axios()
      .get("/api/get/records", { params: { macAddress: __.device.get("mac"), pms_id: __.guest.get("pms_id") } })
      .catch(err => _$.error(err))
  }
  async softap(payload) {
    return axios()
      .post("/api/get/softap", payload)
      .catch(err => _$.error(err))
  }
  async digitalsignage() {
    return axios()
      .get("/api/get/digitalsignage", { params: { location: __.device.get("location_id") } })
      .catch(err => _$.error(err))
  }
  async weather() {
    return axios()
      .get("/api/feeder/weather/")
      .catch(err => _$.error(err))
  }
  async prayer() {
    return axios()
      .get("/api/feeder/prayer/")
      .catch(err => _$.error(err))
  }
  async flight() {
    return axios()
      .get("/api/feeder/flight/")
      .catch(err => _$.error(err))
  }
  async news() {
    return axios()
      .get("/api/feeder/news/")
      .catch(err => _$.error(err))
  }

  async castReservation() {
    const { mac, ip, type, location } = __.device.get()
    return axios()
      .post("/api/cast/get", { macAddress: mac, ipAddress: ip, device: type, room: location })
      .catch(err => _$.error(err))
  }
  async castRemove() {
    const { mac, ip, type } = __.device.get()
    return axios()
      .post("/api/cast/remove", { macAddress: mac, ipAddress: ip, device: type })
      .catch(err => _$.error(err))
  }
  async castHeartbeat() {
    const { mac, ip, type } = __.device.get()
    return axios()
      .post("/api/cast/heartbeat", { macAddress: mac, ipAddress: ip, device: type })
      .catch(err => _$.error(err))
  }
  async rcGetQr() {
    return axios()
      .post("/api/rc/qr", { mac: __.device.get("mac") })
      .catch(err => _$.error(err))
  }
  async orders() {
    const { id, pms_id } = __.guest.get() || {}
    if (!id && !pms_id) return
    return axios()
      .get("/api/get/orders", { params: { guest_id: id, guest_pms: pms_id } })
      .catch(err => _$.error(err))
  }
}

export default new Get()
